export enum EditorType {
  Wizard = "wizard",
  Algorithm = "algorithm",
  Active = "active",
  Planned = "planned",
}
